var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header-div"},[_c('div',{staticClass:"header-div__title"},[_vm._t("title")],2),_c('div',{staticClass:"header-div__content"},[_vm._t("content")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }